// extracted by mini-css-extract-plugin
export var messageSideLeft = "_pr-1";
export var stateContainer = "_pr-0";